<template>
  <div class="flex flex-col gap-2">
    <div>Response</div>
    <div
      v-for="(item, index) in submissions"
      :key="index"
      class="p-2 border border-secondary-20 rounded-md"
    >
      {{ item[0] }}: <b>{{ item[1] }}/{{ highValue }}</b>
    </div>
  </div>
</template>

<script>

import _ from 'lodash'

export default {
  name: 'RatingScale',
  props: {
    report: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      highValue: 0,
    }
  },
  computed: {
    submissions() {
      return this.report?.response?.submissions?.map((item) => {
        const parts = _.split(item.text, '-')
        return [_.join(parts.slice(0, -1), '-'), _.last(parts)]
      })
    },
  },
  mounted() {
    let scale_range = this.report?.scale_range

    try {
      scale_range = JSON.parse(this.report?.scale_range)
    } catch (error) {
      scale_range = {
        highValue: 0,
      }
    }

    this.highValue = scale_range.highValue || 0
  },
}
</script>
